export default __webpack_public_path__ + "static/media/monthly_index.fb06bcda.png";